export const labels = {
  rowValuePath: "create_event_definition.items.rowValuePath",
  columnValuePath: "create_event_definition.items.columnValuePath",
  columnGroupBy: "create_event_definition.items.columnGroupBy",
  rowGroupBy: "create_event_definition.items.rowGroupBy",
  aggCondition: "create_event_definition.items.aggCondition",
  queryWithReplacedParams: "create_event_definition.items.queryWithReplacedParams",
  searchFilterQuery: "create_event_definition.items.searchFilterQuery",
  streams: "create_event_definition.items.streams",
  searchWithinMs: "create_event_definition.items.searchWithinMs",
  lutParameters: "create_event_definition.items.lutParameters",
  searchFromValue: "create_event_definition.items.searchFromValue"
};
export const aggregationGroup = ["columnGroupBy", "rowGroupBy", "aggCondition"];
export const searchGroup = [
  "rowValuePath",
  "columnValuePath",
  "queryWithReplacedParams",
  "searchFilterQuery",
  "searchFromValue"
];
export const strategiesLabels = {
  EXACT: {
    label: "create_event_definition.strategies.EXACT.label",
    description: "create_event_definition.strategies.EXACT.description"
  },
  ROW: {
    label: "create_event_definition.strategies.ROW.label",
    description: "create_event_definition.strategies.ROW.description"
  },
  COL: {
    label: "create_event_definition.strategies.COL.label",
    description: "create_event_definition.strategies.COL.description"
  },
  ALL: {
    label: "create_event_definition.strategies.ALL.label",
    description: "create_event_definition.strategies.ALL.description"
  },
  CUSTOM: {
    label: "create_event_definition.strategies.CUSTOM.label",
    description: "create_event_definition.strategies.CUSTOM.description"
  }
};
